import { title } from "process";
import { FC } from "react";

interface ReservationModalProps {
  message: string;
  title: string;
  isReservationModalOpen: boolean;
  handleReservationModalClose: () => void;
  handleReservation: () => void;
}

const modalStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const ReservationModal: FC<ReservationModalProps> = ({ message , title ,isReservationModalOpen , handleReservationModalClose, handleReservation}) => {

  if (!isReservationModalOpen) {
    return null;
  }

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto" id="my-modal">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0 sm:h-screen sm:items-center sm:flex sm:w-50% " style={modalStyle}>
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:h-fit"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div>
            <div className="w-full flex items-center justify-center">
            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
            <svg className="h-6 w-6 text-green-600 justify-center" stroke="currentColor" fill="none" viewBox="0 0 24 24" >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
            </div>
            </div>
            <div className="mt-3 text-center sm:mt-5">
              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                {title}
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500 pl-5 pr-5">
                  {message}
                </p>
              </div>
            </div>
          </div>
          <div className="mt-5 sm:mt-6 flex justify-between">
            <button
              className=" ml-10 inline-flex justify-center rounded-full border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
              onClick={handleReservationModalClose}>
              Cancelar
            </button>
            <button
              className=" mr-10  inline-flex justify-center rounded-full border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
              onClick={handleReservation}>
              Reservar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationModal;